// Contact.js
import React, { useState } from 'react';
import { Mail, Calendar, MapPin, Instagram, Facebook, ChevronDown, ChevronUp } from 'lucide-react';

const Contact = () => {
  const [isNewsletterExpanded, setIsNewsletterExpanded] = useState(false);

  return (
    <section id="contact" className="py-24 px-4 bg-primary text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-16">Connect With Us</h2>
        <div className="flex justify-center items-center gap-12 mb-12">
          <div className="flex items-center gap-3">
            <Mail size={24} />
            <a href="mailto:info@ruedadance.org" className="hover:underline">
              info@ruedance.org
            </a>
          </div>
        </div>
        
        {/* Newsletter Signup Section */}
        <div className="mb-12">
          <button
            onClick={() => setIsNewsletterExpanded(!isNewsletterExpanded)}
            className="flex items-center justify-center gap-2 mx-auto bg-secondary hover:bg-opacity-80 text-white px-6 py-3 rounded-lg transition-all duration-300"
          >
            <Mail size={20} />
            <span>Sign up for latest updates</span>
            {isNewsletterExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </button>
          
          {/* Expandable Mailchimp Form */}
          <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
            isNewsletterExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}>
            <div className="mt-6 p-6 bg-white bg-opacity-10 rounded-lg backdrop-blur-sm">
              <p className="text-sm mb-4 opacity-90">
                Stay updated with our latest dance events, workshops, and community news!
              </p>
              
              {/* Mailchimp Embedded Form */}
              <div id="mc_embed_signup">
              <form action="https://ruedadance.us13.list-manage.com/subscribe/post?u=6cbbf9bb92fac258bc1f4ec16&amp;id=15d962baa5&amp;f_id=00f251e1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
                  <div id="mc_embed_signup_scroll" className="space-y-4">
                    <div className="mc-field-group">
                      <input 
                        type="email" 
                        name="EMAIL" 
                        className="required email w-full px-4 py-2 rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-secondary" 
                        id="mce-EMAIL" 
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                    
                    {/* Optional: First Name Field */}
                    <div className="mc-field-group">
                      <input 
                        type="text" 
                        name="FNAME" 
                        className="w-full px-4 py-2 rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-secondary" 
                        id="mce-FNAME" 
                        placeholder="First Name (optional)"
                      />
                    </div>
                    
                    {/* Optional: Last Name Field */}
                    <div className="mc-field-group">
                      <input 
                        type="text" 
                        name="LNAME" 
                        className="w-full px-4 py-2 rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-secondary" 
                        id="mce-LNAME" 
                        placeholder="Last Name (optional)"
                      />
                    </div>
                    
                    {/* Hidden bot field */}
                    <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                      <input type="text" name="b_YOUR_USER_ID_YOUR_LIST_ID" tabIndex="-1" />
                    </div>
                    
                    <div className="clear">
                      <input 
                        type="submit" 
                        value="Subscribe" 
                        name="subscribe" 
                        id="mc-embedded-subscribe" 
                        className="bg-secondary hover:bg-opacity-80 text-white font-semibold py-2 px-8 rounded-md cursor-pointer transition-all duration-300 transform hover:scale-105"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex justify-center items-center gap-8">
          <a 
            href="https://www.instagram.com/rueda.de.la.vida/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          >
            <Instagram size={28} />
            <span>@rueda.de.la.vida</span>
          </a>
          <a 
            href="https://www.facebook.com/salsadancinginvancouver" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          >
            <Facebook size={28} />
            <span>Salsa Dancing in Vancouver</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;